import { NavigateFunction } from "react-router-dom";
import { newId } from "../../models/BaseObject";
import { loadProject } from "../LoadProject";
import { saveProject } from "../SaveProject";
import { showNotificationIfUserOffline } from "../../utils/axios";
import { showToast } from "../Toasts";
import { UserReference } from "../../models/ProjectMetadata";
import universalstorageHandler, { enumStorageMode } from "../../persistence/UniversalstorageHandler";
import ProjectLicense from "../../models/ProjectLicense";

export default class ProjectHandleling {
  public get className(): string {
    return "ProjectHandleling";
  }

  async copyProject(
    id: string,
    ev: any,
    navigate: NavigateFunction,
    descrition?: string,
    fromExampleProject?: boolean,
    name?: string,
  ) {
    const status = await loadProject(id);

    if (state.projectMetadata.projectLicence?.invoiceIds) {
      state.projectMetadata.projectLicence.invoiceIds = [];
    }

    if (navigator.onLine && status) {
      //make a copy of project "Beispiel"
      state.projectMetadata.id = newId();
      state.projectMetadata.users = new Array<UserReference>();
      state.projectMetadata.setUserForNewProject();
      state.projectMetadata.lastModifiedOnServer = new Date();
      state.root.id = state.projectMetadata.id;
      // for license handeling
      state.projectMetadata.projectLicence = {
        invoiceIds: [] as Array<string>,
      };
      // the actual licenses live on state.projectLicense (not on projectMetadata.projectLicence),
      // so they must be reset here too, otherwise the copy inherits the original project's licenses
      state.projectLicense = new ProjectLicense({}, state.root);

      state.projectMetadata.persistantAssistanceData.isDemoProject = true;
      state.projectMetadata.persistantAssistanceData.projectOpenCount = 0;
      if (name) {
        state.projectMetadata.name = name;
      }
      if (fromExampleProject && !name) {
        state.projectMetadata.name = state.projectMetadata.name.substring(
          0,
          state.projectMetadata.name.indexOf("(") - 1,
        );
      }

      // check if name is already in list, translate name
      let projectname = state.projectMetadata.name;
      const projectNames = new Array<string>();
      state.allProjectsMap.forEach((project) => {
        if (project.id != state.projectMetadata.id) {
          projectNames.push(project.name);
        }
      });
      while (projectNames.includes(projectname)) {
        projectname = state.noDoubleValue.getCopiedStringText(projectname);
      }
      state.projectMetadata.name = projectname;
      if (descrition) {
        state.projectMetadata.description = descrition;
      }
      //////////////////////////
      // for example project
      if (fromExampleProject) {
        state.projectMetadata.readOnly = fromExampleProject;
        state.projectMetadata.isExampleProject = fromExampleProject;
      }
      ///////////////////////////
      saveProject();
      navigate("/app");
    } else {
      if (!navigator.onLine && universalstorageHandler.storageMode == enumStorageMode.server) {
        showNotificationIfUserOffline();
      }
      if (navigator.onLine && !status) {
        showToast({
          isError: true,
          text: state.translate(
            "homePage.projectLoadError",
            "Beim Laden von Projektelementen ist ein Fehler aufgetreten",
          ),
        });
        const elm: any = ev.target;
        elm.innerHTML = state.translate("homePage.load", "Load");
        elm.style.backgroundColor = "var(--colorTransparent)";
      }
    }
  }
}
